import { disableLoader, enableLoader } from '@context/actions';
import { getStoresByTenantIdMysql } from '@storeData/store';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  FaPhoneAlt,
  ImLocation,
  MdEmail
} from '@element/icons';
const StoreLocator = ({ storeData }) => {

    const [storesList, setStoresList] = useState([])
    const dispatch = useDispatch();
    const baseRouteUrl = useSelector((state: any) => state.store.baseRouteUrl);
    const storeMetaData = useSelector((state: any) => state.store ? state.store.storeMetaData : null);
    const { configData } = useSelector((state: any) => state.store ? state.store.storeData : null);
    const basicConfig = configData?.storeConfig?.basicConfig

    useEffect(() => {
        if (storeData.tenantId) {
            dispatch(enableLoader());
            getStoresByTenantIdMysql(storeData.tenantId).then((res: any) => {
                dispatch(disableLoader());
                setStoresList(res);
            }).catch((err) => {
                dispatch(disableLoader());
                console.error(err)
            })
        }
    }, [storeData])

    const onClickType = (type: any, data: any = {}) => {
        switch (type) {
            case 'phone':
                window.open(`tel:${data.phone?.length == 10 ? `${storeMetaData.countryCode} ` : ''}${data.phone}`, '_self')
                break;
            case 'location':
                window.open(`${data.googleMapUrl ? data.googleMapUrl : `https://www.google.com/maps/search/?api=1&query=${data.latitude},${data.longitude}`}`, '_blank')
                break;
            case 'email':
                window.open(`mailto:${data.email}`, '_self')
                break;

            default:
                break;
        }
    }

    return (
        <div className='store-locator-wrap'>
            {storesList && storesList.length != 0 && storesList.map((storeData: any, i: number) => {
                return <div key={Math.random()} className='store-details'>
                    <div className='name'>{storeData.store}</div>
                    <div className="information-wrap">
                        <div className="icon glass-card" onClick={() => onClickType('location', storeData)}>
                            <ImLocation />
                        </div>
                        <span className="containt" style={{ textTransform: 'capitalize' }}>
                            <a href={storeData.googleMapUrl} rel="noreferrer" target="_blank">
                                {storeData.address}, {storeData.area}, {storeData.city}, {storeData.state}, {storeData.pincode}
                            </a>
                        </span>
                    </div>
                    <div className="information-wrap">
                        <div className="icon glass-card" onClick={() => onClickType('phone', storeData)}>
                            <FaPhoneAlt />
                        </div>
                        <span className="containt">
                            {storeData.phone && <a href={`tel:${storeData.phone?.length == 10 ? `+${storeMetaData.countryCode} ` : ''}${storeData.phone}`}>
                                {basicConfig.multipleCountryCode ? "+" + storeMetaData.countryCode + " " : <>&nbsp;&nbsp;&nbsp;</>}{storeData.phone}
                            </a>}
                            {storeData.phone1 && <><br /><a style={{ paddingLeft: '10px' }} href={`tel:+${storeMetaData.countryCode} ${storeData.phone1}`}>{storeMetaData.countryCode} {storeData.phone1}</a></>}
                        </span>
                    </div>
                    {storeData.email && <div className="information-wrap">

                        <div className="icon glass-card" onClick={() => onClickType('email', storeData)}>
                            <MdEmail />
                        </div>
                        {/* <a href={`mailto:${storeData.email}`} rel="noreferrer" target="_blank" className='icon glass-card'><MdEmail /></a> */}
                        <span className="containt"> <a href={`mailto:${storeData.email}`} rel="noreferrer" target="_blank">{storeData.email}</a></span>
                    </div>}
                </div>
            })}
        </div>
    )
}

export default StoreLocator